import TrashButton from "./TrashButton";

export default TrashButton;